import { useCappsLandlordInvitationsWebApiHandler_getInvitedApplicants } from '@zg-rentals/ts-capps-client-react-query';

export function useGetInvitedApplicants(listingAlias: string) {
  return useCappsLandlordInvitationsWebApiHandler_getInvitedApplicants({ listingAlias });
}
